import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedPipesModule } from '../../pipes/shared-pipes.module';
import { KpiTooltipComponent } from './kpi-tooltip.component';

@NgModule({
  declarations: [KpiTooltipComponent],
  imports: [CommonModule, SharedPipesModule],
  exports: [KpiTooltipComponent]
})
export class KpiTooltipModule {}
